"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionLicenseEnum = void 0;
/** Типы лицензий для коллекций и курсов */
var CollectionLicenseEnum;
(function (CollectionLicenseEnum) {
  /** Базовый доступ (Личный доступ) */
  CollectionLicenseEnum[CollectionLicenseEnum["personal"] = 1] = "personal";
  /** Профессиональный доступ (Использование на занятиях) */
  CollectionLicenseEnum[CollectionLicenseEnum["professional"] = 2] = "professional";
  /** Бизнес доступ (Испольование в школах) */
  CollectionLicenseEnum[CollectionLicenseEnum["business"] = 3] = "business";
})(CollectionLicenseEnum = exports.CollectionLicenseEnum || (exports.CollectionLicenseEnum = {}));
